<template>
  <div id="bofqi">
    <div ref="eduPlayerHomeBoFangQi"></div>
  </div>
</template>

<script>
/* eslint-disable */

import EduPlayer from '@bilibili/edu-player/src/pc-player-new';

export default {
  name: 'player',
  props: {
    config: Object,
    playState: Boolean,
    onEpisodeEnd: Function,
    inited: Function,
    needReplay: Boolean,
    reloadCallback: Function
  },
  data() {
    return {
      eduPlayer: null,
    };
  },
  computed: {
    getEpisodeId() {
      return this.config.episodeId
    }
  },
  watch: {
    needReplay(newVal) {
      if (this.eduPlayer && this.getEpisodeId && newVal === true) {
        this.eduPlayer.replay()
      }
    },
    getEpisodeId(newVal) {
      if (!newVal) return
      if (!this.eduPlayer) {
        this.initPlayer({
          seasonId: this.config.seasonId,
          episodeId: newVal
        })
      } else {
        this.reloadPlayer({
          seasonId: this.config.seasonId,
          episodeId: newVal
        })
      }
    },
    playState(newVal) {
      if (!newVal) {
        this.eduPlayer && this.eduPlayer.pause()
      } else {
        this.eduPlayer && this.eduPlayer.play()
      }
    },
  },
  methods: {
    initPlayer(options) {
      this.eduPlayer = new EduPlayer({
        seasonId: options.seasonId,
        episodeId: options.episodeId,
        boFangQiElement: this.$refs.eduPlayerHomeBoFangQi,
        isHomeCardMode: true,
      })
      this.eduPlayer.render()
      this.eduPlayer.bus.$on(this.eduPlayer.EventType.Edu_Player_Enter_EP, () => {
        this.$emit('enterEP')
      })
      this.eduPlayer.bus.$on(this.eduPlayer.EventType.Edu_Player_Player_Ended, () => {
        this.onEpisodeEnd()
      })

      this.eduPlayer.bus.$on(this.eduPlayer.EventType.Edu_Player_Player_Connected, () => {
        this.inited()
      })
    },
    reloadPlayer(options) {
      const manifest = this.eduPlayer.manifest()
      if (`${manifest.episodeId}` !== `${options.episodeId}`) {
        this.eduPlayer.reload({
          seasonId: options.seasonId,
          episodeId: options.episodeId,
        })
      } else {
        this.eduPlayer.play()
      }
      this.reloadCallback()
    }
  },
  beforeDestroy() {
    this.eduPlayer.destroy()
  }
};
</script>
<style lang="less" scoped>
#bofqi {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 99;
  width: 100%;
  height: 550px;
}

@media screen and (max-width: 1438px) {
  #bofqi {
    height: 460px;
  }
}
</style>
